// extracted by mini-css-extract-plugin
module.exports = {"product-cards":"ProductCards_product-cards__QoeUK"};